import { z } from "zod";

import { packagingSolutionProducedSchema } from "../packaging-solution";

import { auditEventBaseSchema } from "./audit-event-base";
import { auditEventTypeSchema } from "./audit-event-type";

export const auditEventRetractedSchema = auditEventBaseSchema.extend({
	auditType: z.literal(auditEventTypeSchema.enum.Retracted),
	data: packagingSolutionProducedSchema,
});

export type AuditEventRetracted = z.infer<typeof auditEventRetractedSchema>;
